/**
 * Exponential smoothing measured in seconds instead of frames, so whatever
 * eases this way moves the same on a 60Hz, a 120Hz or any other screen.
 *
 * To keep the feel of a per-frame lerp `k` tuned at refresh rate `f`, use the
 * time constant −(1/f) / ln(1 − k).
 */

// A long frame (tab switch, jank) counts as at most this long, so anything
// timed by it takes a bounded step instead of jumping to where it's heading.
export const MAX_FRAME_SECONDS = 0.05;

// Make one per animation loop and call it once per frame with the
// requestAnimationFrame timestamp: it returns the seconds since the loop's
// previous frame, 0 on its first frame and at most MAX_FRAME_SECONDS.
export function createFrameClock() {
  let lastFrame = null;
  return (now) => {
    const dt = lastFrame === null ? 0 : Math.min(MAX_FRAME_SECONDS, (now - lastFrame) / 1000);
    lastFrame = now;
    return dt;
  };
}

// Share of the remaining gap to a target that smoothing with this time
// constant (in seconds) closes in dt seconds:
// value += (target - value) * smoothingFactor(dt, timeConstant)
export function smoothingFactor(dt, timeConstant) {
  return 1 - Math.exp(-dt / timeConstant);
}
